
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const ResellerCTA: React.FC = () => {
  return (
    <section className="bg-primary-blue text-white py-16 text-center">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-6">
          Ready to Start Your Reseller Journey?
        </h2>
        <p className="text-xl mb-10">
          Join our platform and start building your referral business today
        </p>
        <Link to="/business-reseller-order">
          <Button 
            size="lg" 
            variant="secondary" 
            className="bg-white text-primary-blue hover:bg-gray-100"
          >
            Get Started Now
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default ResellerCTA;

